import { FavoriteCubeItem } from '@selfai-platform/pipeline-common';
import { Observable } from 'rxjs';

export abstract class FavoriteCubeListAdapter {
  abstract loadList(): Observable<FavoriteCubeItem[]>;
  abstract add(item: Omit<FavoriteCubeItem, 'id'>): Observable<{ id: string }>;
  abstract remove(id: string): Observable<void>;
}
